module.exports = __webpack_public_path__ + "img/icon2.8d07b0d5.png";